import { usePreventScrollOnKeyboardOpen } from "@/shared/hooks/usePreventScrollOnKeyboardOpen";

export function usePreventScrollOnEditorFocus() {
  usePreventScrollOnKeyboardOpen();
}
